import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { getTheme, callAPI } from 'helpers'
import { Route, Switch, Redirect, useLocation, useHistory, Link } from 'react-router-dom'
import Cookies from 'js-cookie'
import theme from 'theme'

// Containers
import OnlineClasses from 'containers/OnlineClasses'
import Exams from 'containers/Exams'

// Components
import GridContainer from 'components/GridContainer'
import { Icon } from 'antd'

const MOBILE_MENU_WIDTH = 300

export default function () {
  const location = useLocation()
  const history = useHistory()

  const [menusVisible, setMenusVisible] = useState()

  useEffect(() => {
    const verify = async () => {
      try {
        await callAPI({ url: '/admins/me' })
      } catch (error) {
        Cookies.remove('accessToken')
        history.replace('/login')
      }
    }

    verify()
  }, [])

  const [loggingOut, setLoggingOut] = useState(false)
  const _onLogout = async () => {
    if (loggingOut) return
    try {
      setLoggingOut(true)
      await callAPI({
        method: 'POST',
        url: '/admins/logout'
      })
      Cookies.remove('accessToken')
      window.location.href = '/'
      setLoggingOut(false)
    } catch (error) {
      console.error('Error while trying to log out.', error)
      setLoggingOut(false)
    }
  }

  if (location.pathname === '/login') return null
  return (
    <section>
      <Container menusVisible={menusVisible}>
        {location.pathname !== '/login' && (
          <Navbar style={{ left: menusVisible ? MOBILE_MENU_WIDTH : 0 }}>
            <CustomGridContainer style={{ position: 'relative' }}>
              <NavLogo src='/images/logo-oplus.png' />
              <DesktopNavLinks>
                <Link to='/online-classes'>
                  <NavLink isActive={location.pathname.indexOf('/online-classes') > -1}>คอร์สออนไลน์</NavLink>
                </Link>
                <Link to='/exams'>
                  <NavLink isActive={location.pathname.indexOf('/exams') > -1}>แบบทดสอบ</NavLink>
                </Link>
              </DesktopNavLinks>
              <BtnLogout onClick={_onLogout}>
                {loggingOut ? <Icon type='loading' /> : <span>ออกจากระบบ</span>}
              </BtnLogout>
              <BtnMenuToggle onClick={() => setMenusVisible(visible => !visible)}>
                <Icon type='menu' />
              </BtnMenuToggle>
            </CustomGridContainer>
          </Navbar>
        )}
        <div style={{ width: '100vw' }}>
          <Switch>
            <Route path='/online-classes' component={OnlineClasses} />
            <Route path='/exams' component={Exams} />
            <Redirect to='/login' />
          </Switch>
        </div>
      </Container>
      <MobileNavLinks style={{ left: menusVisible ? 0 : -MOBILE_MENU_WIDTH }}>
        <MobileNavLinksHead>
          <BtnCloseMobileNavLinks onClick={() => setMenusVisible(false)}>
            <Icon type='close' />
          </BtnCloseMobileNavLinks>
        </MobileNavLinksHead>
        <Link to='/online-classes'>
          <NavLink
            onClick={() => setMenusVisible(false)}
            isActive={location.pathname.indexOf('/online-classes') > -1}>คอร์สออนไลน์</NavLink>
        </Link>
        <Link to='/exams'>
          <NavLink
            onClick={() => setMenusVisible(false)}
            isActive={location.pathname.indexOf('/exams') > -1}>แบบทดสอบ</NavLink>
        </Link>
      </MobileNavLinks>
    </section>
  )
}

const Container = styled.div`
  background-color: ${getTheme`colors.background`};
  padding-top: 50px;
  min-height: 100vh;
  transition: margin-left 0.3s ease;
  position: relative;
  ${props => props.menusVisible ? `
    margin-left: ${MOBILE_MENU_WIDTH}px;
    &:after {
      content: '';
      z-index: ${999 + 1};
      background-color: rgba(0, 0, 0, 0.7);
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
    }
  ` : `
    margin-left: 0px;
  `}
`
const CustomGridContainer = styled(GridContainer)`
  @media(max-width: ${theme.media.mobile}) {
    text-align: center;
  }
`
const Navbar = styled.div`
  background-color: ${getTheme`colors.primary`};
  height: 50px;
  position: fixed;
  top: 0px;
  transition: left 0.3s ease;
  width: 100vw;
  z-index: 999;
`
const NavLogo = styled.img`
  height: 30px;
  object-fit: cover;
  filter: brightness(0) invert(1);
  display: inline-block;
  vertical-align: top;
  margin-top: 10px;
`
const DesktopNavLinks = styled.div`
  @media(min-width: ${theme.media.desktop}) {
    display: inline-block;
    vertical-align: top;
    margin-left: 20px;
  }
  @media(max-width: ${theme.media.mobile}) {
    display: none;
  }
`
const BtnMenuToggle = styled.div`
  @media(min-width: ${theme.media.desktop}) { display: none; }
  @media(max-width: ${theme.media.mobile}) {
    cursor: pointer;
    width: 50px;
    height: 50px;
    line-height: 50px;
    position: absolute;
    top: 0px;
    left: 0px;
    text-align: center;
    color: white;
    z-index: 1;

    > i {
      font-size: 26px;
      margin-top: 12px;
    }
  }
`

const BtnLogout = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: inline-block;
  vertical-align: top;
  color: white;
  cursor: pointer;
  transition: background-color 0.3s ease;
  line-height: 50px;
  
  @media(min-width: ${theme.media.desktop}) {
    padding: 0px 20px;
    width: 120px;
    text-align: center;
    ${props => props.isActive && `
      background-color: ${props.theme.colors.secondary}
      &:hover {
        color: white;
      }
    `}
  }
  @media(max-width: ${theme.media.mobile}) {

  }
`
const NavLink = styled.span`
  @media(min-width: ${theme.media.desktop}) {
    display: inline-block;
    vertical-align: top;
    line-height: 50px;
    padding: 0px 20px;
    color: white;
    transition: background-color 0.3s ease;
    ${props => props.isActive && `
      background-color: ${props.theme.colors.secondary};
      &:hover {
        color: white;
      }
    `}
  }
  @media(max-width: ${theme.media.mobile}) {
    display: block;
    height: 50px;
    line-height: 50px;
    color: black;
    border-bottom: ${getTheme`colors.border`};
    font-size: 18px;
    font-weight: 700;
    text-indent: 10px;
    ${props => props.isActive && `
      color: ${props.theme.colors.secondary};
    `}
  }
`
const MobileNavLinks = styled.div`
  background-color: white;
  width: ${MOBILE_MENU_WIDTH}px;
  height: 100vh;
  position: fixed;
  top: 0px;
  z-index: ${999 + 1};
  transition: left 0.3s ease;
`
const MobileNavLinksHead = styled.div`
  text-align: right;
`
const BtnCloseMobileNavLinks = styled.div`
  display: inline-block;
  vertical-align: top;
  width: 50px;
  height: 49px;
  line-height: 49px;
  text-align: center;
  > i {
    color: black;
    font-size: 26px;
    margin-top: 12px;
  }
`



// WEBPACK FOOTER //
// ./src/App.js